import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import GlassCard from '../../../shared/components/card/GlassCard';
import '../../../styles/Eula.css';

const EulaModal = () => {
  const [eulaData, setEulaData] = useState(null);
  const [formattedEula, setFormattedEula] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isAccepted, setIsAccepted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [hasScrolledToBottom, setHasScrolledToBottom] = useState(false);
  const { getEula, acceptEula,notAcceptEula } = useAuth();
  const contentRef = useRef(null);
  const modalRef = useRef(null);

  const formatEulaToHtml = (text) => {
    if (!text) return '';
    
    let html = text
      // Escapar HTML para seguridad
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      
      // Título principal (líneas en negrita con ** o __)
      .replace(/^\*\*(.+?)\*\*$/gm, '<h1 class="eula-main-title">$1</h1>')
      .replace(/^__(.+?)__$/gm, '<h1 class="eula-main-title">$1</h1>')
      
      // Subtítulos (## o líneas que empiezan con número y punto)
      .replace(/^##\s*(.+?)$/gm, '<h2 class="eula-section-title">$1</h2>')
      .replace(/^\d+\.\s+(.+?)$/gm, '<h3 class="eula-subsection-title">$1</h3>')
      
      // Sub-subtítulos (### o líneas con ###)
      .replace(/^###\s*(.+?)$/gm, '<h4 class="eula-subsection-title">$1</h4>')
      
      // Listas con asteriscos
      .replace(/^\*\s+(.+?)$/gm, '<li class="eula-list-item">$1</li>')
      
      // Separadores horizontales
      .replace(/^---$/gm, '<hr class="eula-divider">')
      
      // Párrafos (líneas que no están vacías y no son títulos/listas)
      .replace(/^(?!<[hl]|<li)(.+?)$/gm, '<p class="eula-paragraph">$1</p>')
      
      // Envolver listas consecutivas en <ul>
      .replace(/(<li class="eula-list-item">.+?<\/li>\n?)+/g, '<ul class="eula-list">$&</ul>')
      
      // Limpiar saltos de línea excesivos
      .replace(/\n{3,}/g, '\n\n')
      .replace(/\n/g, '');

    return html;
  };

  // Cargar EULA desde el endpoint
  useEffect(() => {
    const fetchEula = async () => {
      setIsLoading(true);
      setError(null);
      
      try {
        const eula = await getEula(); //CAMBIAR CUANDO PROD
        console.log(eula.data);
        setEulaData(eula.data);
        
        // Formatear el contenido
        const formatted = formatEulaToHtml(eula.data);
        setFormattedEula(formatted)
        //setFormattedEula("橘子是一种非常受欢迎的水果，在中国和世界许多地方都被广泛种植。橘子属于柑橘类水果，味道通常甜中带酸，汁水丰富，营养价值很高。很多人喜欢在冬天吃橘子，因为这个季节正是橘子成熟的时候，新鲜的橘子香气浓郁，口感清爽。橘子的外皮一般是橙色或者橙黄色，比较容易剥开，这也是它受欢迎的原因之一。与一些柑橘类水果不同，橘子通常可以用手轻松地把皮剥下来，不需要使用刀子。剥开之后，可以看到一瓣一瓣的果肉，每一瓣都被一层很薄的膜包裹着，里面充满了甜美的汁液。橘子不仅味道好，而且含有很多对人体有益的营养成分。例如，它含有丰富的维生素C，可以帮助增强免疫系统。除此之外，橘子还含有纤维、抗氧化物质以及多种矿物质，这些成分都有助于维持身体健康。因此，许多营养学家都建议在日常饮食中适量食用柑橘类水果。在中国文化中，橘子也有特殊的象征意义。因为“橘”字的发音与“吉”相近，所以橘子常常被认为象征着好运和吉祥。在春节期间，人们经常会把橘子摆在家里或者作为礼物送给亲朋好友，希望新的一年能够顺利、幸福和繁荣。中国南方的一些地区，例如广东、广西和福建，非常适合种植橘子。那里气候温暖、降雨充足、阳光丰富，这些条件都非常有利于橘子的生长。当地的农民会在果园里种植大量的橘子树，每到收获季节，果园里就会挂满橙色的果实，看起来非常壮观。橘子的品种也很多，比如蜜橘、砂糖橘、椪柑和丑橘等。不同的品种在口味、大小和外观上都有一些差别。有些橘子特别甜，有些则带有一点酸味。消费者可以根据自己的喜好选择不同的品种。除了直接食用之外，橘子还可以被用来制作很多食品。例如橘子汁、橘子果酱、橘子蛋糕以及各种甜点。在一些地方，人们还会把橘子皮晒干，用来泡茶或者作为中药材。橘子皮在中医里被称为“陈皮”，被认为有助于消化和调理身体。总的来说，橘子是一种既美味又健康的水果。无论是在日常生活中作为零食，还是在节日里作为象征好运的礼物，橘子都在人们的生活中占据着重要的位置。橘子是一种非常受欢迎的水果，在中国和世界许多地方都被广泛种植。橘子属于柑橘类水果，味道通常甜中带酸，汁水丰富，营养价值很高。很多人喜欢在冬天吃橘子，因为这个季节正是橘子成熟的时候，新鲜的橘子香气浓郁，口感清爽。橘子的外皮一般是橙色或者橙黄色，比较容易剥开，这也是它受欢迎的原因之一。与一些柑橘类水果不同，橘子通常可以用手轻松地把皮剥下来，不需要使用刀子。剥开之后，可以看到一瓣一瓣的果肉，每一瓣都被一层很薄的膜包裹着，里面充满了甜美的汁液。橘子不仅味道好，而且含有很多对人体有益的营养成分。例如，它含有丰富的维生素C，可以帮助增强免疫系统。除此之外，橘子还含有纤维、抗氧化物质以及多种矿物质，这些成分都有助于维持身体健康。因此，许多营养学家都建议在日常饮食中适量食用柑橘类水果。在中国文化中，橘子也有特殊的象征意义。因为“橘”字的发音与“吉”相近，所以橘子常常被认为象征着好运和吉祥。在春节期间，人们经常会把橘子摆在家里或者作为礼物送给亲朋好友，希望新的一年能够顺利、幸福和繁荣。中国南方的一些地区，例如广东、广西和福建，非常适合种植橘子。那里气候温暖、降雨充足、阳光丰富，这些条件都非常有利于橘子的生长。当地的农民会在果园里种植大量的橘子树，每到收获季节，果园里就会挂满橙色的果实，看起来非常壮观。橘子的品种也很多，比如蜜橘、砂糖橘、椪柑和丑橘等。不同的品种在口味、大小和外观上都有一些差别。有些橘子特别甜，有些则带有一点酸味。消费者可以根据自己的喜好选择不同的品种。除了直接食用之外，橘子还可以被用来制作很多食品。例如橘子汁、橘子果酱、橘子蛋糕以及各种甜点。在一些地方，人们还会把橘子皮晒干，用来泡茶或者作为中药材。橘子皮在中医里被称为“陈皮”，被认为有助于消化和调理身体。总的来说，橘子是一种既美味又健康的水果。无论是在日常生活中作为零食，还是在节日里作为象征好运的礼物，橘子都在人们的生活中占据着重要的位置。橘子是一种非常受欢迎的水果，在中国和世界许多地方都被广泛种植。橘子属于柑橘类水果，味道通常甜中带酸，汁水丰富，营养价值很高。很多人喜欢在冬天吃橘子，因为这个季节正是橘子成熟的时候，新鲜的橘子香气浓郁，口感清爽。橘子的外皮一般是橙色或者橙黄色，比较容易剥开，这也是它受欢迎的原因之一。与一些柑橘类水果不同，橘子通常可以用手轻松地把皮剥下来，不需要使用刀子。剥开之后，可以看到一瓣一瓣的果肉，每一瓣都被一层很薄的膜包裹着，里面充满了甜美的汁液。橘子不仅味道好，而且含有很多对人体有益的营养成分。例如，它含有丰富的维生素C，可以帮助增强免疫系统。除此之外，橘子还含有纤维、抗氧化物质以及多种矿物质，这些成分都有助于维持身体健康。因此，许多营养学家都建议在日常饮食中适量食用柑橘类水果。在中国文化中，橘子也有特殊的象征意义。因为“橘”字的发音与“吉”相近，所以橘子常常被认为象征着好运和吉祥。在春节期间，人们经常会把橘子摆在家里或者作为礼物送给亲朋好友，希望新的一年能够顺利、幸福和繁荣。中国南方的一些地区，例如广东、广西和福建，非常适合种植橘子。那里气候温暖、降雨充足、阳光丰富，这些条件都非常有利于橘子的生长。当地的农民会在果园里种植大量的橘子树，每到收获季节，果园里就会挂满橙色的果实，看起来非常壮观。橘子的品种也很多，比如蜜橘、砂糖橘、椪柑和丑橘等。不同的品种在口味、大小和外观上都有一些差别。有些橘子特别甜，有些则带有一点酸味。消费者可以根据自己的喜好选择不同的品种。除了直接食用之外，橘子还可以被用来制作很多食品。例如橘子汁、橘子果酱、橘子蛋糕以及各种甜点。在一些地方，人们还会把橘子皮晒干，用来泡茶或者作为中药材。橘子皮在中医里被称为“陈皮”，被认为有助于消化和调理身体。总的来说，橘子是一种既美味又健康的水果。无论是在日常生活中作为零食，还是在节日里作为象征好运的礼物，橘子都在人们的生活中占据着重要的位置。橘子是一种非常受欢迎的水果，在中国和世界许多地方都被广泛种植。橘子属于柑橘类水果，味道通常甜中带酸，汁水丰富，营养价值很高。很多人喜欢在冬天吃橘子，因为这个季节正是橘子成熟的时候，新鲜的橘子香气浓郁，口感清爽。橘子的外皮一般是橙色或者橙黄色，比较容易剥开，这也是它受欢迎的原因之一。与一些柑橘类水果不同，橘子通常可以用手轻松地把皮剥下来，不需要使用刀子。剥开之后，可以看到一瓣一瓣的果肉，每一瓣都被一层很薄的膜包裹着，里面充满了甜美的汁液。橘子不仅味道好，而且含有很多对人体有益的营养成分。例如，它含有丰富的维生素C，可以帮助增强免疫系统。除此之外，橘子还含有纤维、抗氧化物质以及多种矿物质，这些成分都有助于维持身体健康。因此，许多营养学家都建议在日常饮食中适量食用柑橘类水果。在中国文化中，橘子也有特殊的象征意义。因为“橘”字的发音与“吉”相近，所以橘子常常被认为象征着好运和吉祥。在春节期间，人们经常会把橘子摆在家里或者作为礼物送给亲朋好友，希望新的一年能够顺利、幸福和繁荣。中国南方的一些地区，例如广东、广西和福建，非常适合种植橘子。那里气候温暖、降雨充足、阳光丰富，这些条件都非常有利于橘子的生长。当地的农民会在果园里种植大量的橘子树，每到收获季节，果园里就会挂满橙色的果实，看起来非常壮观。橘子的品种也很多，比如蜜橘、砂糖橘、椪柑和丑橘等。不同的品种在口味、大小和外观上都有一些差别。有些橘子特别甜，有些则带有一点酸味。消费者可以根据自己的喜好选择不同的品种。除了直接食用之外，橘子还可以被用来制作很多食品。例如橘子汁、橘子果酱、橘子蛋糕以及各种甜点。在一些地方，人们还会把橘子皮晒干，用来泡茶或者作为中药材。橘子皮在中医里被称为“陈皮”，被认为有助于消化和调理身体。总的来说，橘子是一种既美味又健康的水果。无论是在日常生活中作为零食，还是在节日里作为象征好运的礼物，橘子都在人们的生活中占据着重要的位置。橘子是一种非常受欢迎的水果，在中国和世界许多地方都被广泛种植。橘子属于柑橘类水果，味道通常甜中带酸，汁水丰富，营养价值很高。很多人喜欢在冬天吃橘子，因为这个季节正是橘子成熟的时候，新鲜的橘子香气浓郁，口感清爽。橘子的外皮一般是橙色或者橙黄色，比较容易剥开，这也是它受欢迎的原因之一。与一些柑橘类水果不同，橘子通常可以用手轻松地把皮剥下来，不需要使用刀子。剥开之后，可以看到一瓣一瓣的果肉，每一瓣都被一层很薄的膜包裹着，里面充满了甜美的汁液。橘子不仅味道好，而且含有很多对人体有益的营养成分。例如，它含有丰富的维生素C，可以帮助增强免疫系统。除此之外，橘子还含有纤维、抗氧化物质以及多种矿物质，这些成分都有助于维持身体健康。因此，许多营养学家都建议在日常饮食中适量食用柑橘类水果。在中国文化中，橘子也有特殊的象征意义。因为“橘”字的发音与“吉”相近，所以橘子常常被认为象征着好运和吉祥。在春节期间，人们经常会把橘子摆在家里或者作为礼物送给亲朋好友，希望新的一年能够顺利、幸福和繁荣。中国南方的一些地区，例如广东、广西和福建，非常适合种植橘子。那里气候温暖、降雨充足、阳光丰富，这些条件都非常有利于橘子的生长。当地的农民会在果园里种植大量的橘子树，每到收获季节，果园里就会挂满橙色的果实，看起来非常壮观。橘子的品种也很多，比如蜜橘、砂糖橘、椪柑和丑橘等。不同的品种在口味、大小和外观上都有一些差别。有些橘子特别甜，有些则带有一点酸味。消费者可以根据自己的喜好选择不同的品种。除了直接食用之外，橘子还可以被用来制作很多食品。例如橘子汁、橘子果酱、橘子蛋糕以及各种甜点。在一些地方，人们还会把橘子皮晒干，用来泡茶或者作为中药材。橘子皮在中医里被称为“陈皮”，被认为有助于消化和调理身体。总的来说，橘子是一种既美味又健康的水果。无论是在日常生活中作为零食，还是在节日里作为象征好运的礼物，橘子都在人们的生活中占据着重要的位置。橘子是一种非常受欢迎的水果，在中国和世界许多地方都被广泛种植。橘子属于柑橘类水果，味道通常甜中带酸，汁水丰富，营养价值很高。很多人喜欢在冬天吃橘子，因为这个季节正是橘子成熟的时候，新鲜的橘子香气浓郁，口感清爽。橘子的外皮一般是橙色或者橙黄色，比较容易剥开，这也是它受欢迎的原因之一。与一些柑橘类水果不同，橘子通常可以用手轻松地把皮剥下来，不需要使用刀子。剥开之后，可以看到一瓣一瓣的果肉，每一瓣都被一层很薄的膜包裹着，里面充满了甜美的汁液。橘子不仅味道好，而且含有很多对人体有益的营养成分。例如，它含有丰富的维生素C，可以帮助增强免疫系统。除此之外，橘子还含有纤维、抗氧化物质以及多种矿物质，这些成分都有助于维持身体健康。因此，许多营养学家都建议在日常饮食中适量食用柑橘类水果。在中国文化中，橘子也有特殊的象征意义。因为“橘”字的发音与“吉”相近，所以橘子常常被认为象征着好运和吉祥。在春节期间，人们经常会把橘子摆在家里或者作为礼物送给亲朋好友，希望新的一年能够顺利、幸福和繁荣。中国南方的一些地区，例如广东、广西和福建，非常适合种植橘子。那里气候温暖、降雨充足、阳光丰富，这些条件都非常有利于橘子的生长。当地的农民会在果园里种植大量的橘子树，每到收获季节，果园里就会挂满橙色的果实，看起来非常壮观。橘子的品种也很多，比如蜜橘、砂糖橘、椪柑和丑橘等。不同的品种在口味、大小和外观上都有一些差别。有些橘子特别甜，有些则带有一点酸味。消费者可以根据自己的喜好选择不同的品种。除了直接食用之外，橘子还可以被用来制作很多食品。例如橘子汁、橘子果酱、橘子蛋糕以及各种甜点。在一些地方，人们还会把橘子皮晒干，用来泡茶或者作为中药材。橘子皮在中医里被称为“陈皮”，被认为有助于消化和调理身体。总的来说，橘子是一种既美味又健康的水果。无论是在日常生活中作为零食，还是在节日里作为象征好运的礼物，橘子都在人们的生活中占据着重要的位置。");
      } catch (err) {
        setError(err.message || 'Error al cargar los términos y condiciones');
      } finally {
        setIsLoading(false);
      }
    };

    fetchEula();
  },[]);

  // Focus trap y Escape key
  useEffect(() => {

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        // Opcional: permitir cerrar con Escape solo si no es crítico
        // onDecline();
      }
      
      // Focus trap
      if (e.key === 'Tab') {
        const focusableElements = modalRef.current?.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        
        if (focusableElements.length > 0) {
          const firstElement = focusableElements[0];
          const lastElement = focusableElements[focusableElements.length - 1];

          if (e.shiftKey && document.activeElement === firstElement) {
            lastElement.focus();
            e.preventDefault();
          } else if (!e.shiftKey && document.activeElement === lastElement) {
            firstElement.focus();
            e.preventDefault();
          }
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden'; // Prevenir scroll del body
    
    // Focus inicial en el modal
    setTimeout(() => {
      modalRef.current?.focus();
    }, 100);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  },[]);

  // Detectar scroll hasta el final
  const handleScroll = () => {
    const element = contentRef.current;
    if (!element) return;
    
    const isAtBottom = 
      element.scrollHeight - element.scrollTop <= element.clientHeight + 50; // tolerancia de 50px
    
    if (isAtBottom && !hasScrolledToBottom) {
      setHasScrolledToBottom(true);
    }
  };

  const handleAccept = async () => {
    if (!isAccepted) return;
      
    setIsSubmitting(true);
    setError(null); // Limpiar error previo
    
    try {
      const response = await acceptEula();
      
      // ✅ Comprobación 1: Verificar que existe respuesta
      if (!response) {
        throw new Error('No se recibió respuesta del servidor');
      }
      
      // ✅ Comprobación 2: Verificar status HTTP 200
      if (response.status !== 200) {
        throw new Error(`Error del servidor: ${response.status} ${response.statusText}`);
      }
      
      // ✅ Comprobación 3: Verificar que el body tiene datos esperados (opcional)
      const data = await response.json?.() || response.data;
      
      if (data && !data.success && data.success !== undefined) {
        throw new Error(data.message || 'La operación no fue exitosa');
      }
      
      console.log("EULA aceptado correctamente", data);
      
    } catch (err) {
      // Distinguir entre errores de red y errores del servidor
      if (err.name === 'TypeError' && err.message.includes('fetch')) {
        setError('Error de conexión. Verifica tu internet.');
      } else if (err.response) {
        // Error con respuesta del servidor (4xx, 5xx)
        setError(`Error ${err.response.status}: ${err.response.data?.message || 'Error del servidor'}`);
      } else {
        setError(err.message || 'Error al registrar la aceptación. Intenta de nuevo.');
      }
      
      console.error("Error al aceptar EULA:", err);
      
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDecline = () => {
    notAcceptEula();
  };

  return (
    <div 
      className="eula-overlay" 
      role="dialog" 
      aria-modal="true"
      aria-labelledby="eula-title"
      aria-describedby="eula-content"
    >
        <GlassCard maxWidth='100%' paddingTopBottom='20px'>
          {/* Header */}
          <div className="eula-header">
            <h2 id="eula-title" className="eula-title">
              {isLoading ? 'Cargando...' : 'Términos y Condiciones'}
            </h2>
          </div>

          {/* Estado de carga */}
          {isLoading && (
            <div className="eula-loading">
              <div className="loader-eula"></div>
              <p>Cargando términos y condiciones...</p>
            </div>
          )}

          {/* Error */}
          {error && !isLoading && (
            <div className="eula-error">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
              <span>{error}</span>
              <button 
                onClick={() => window.location.reload()} 
                className="eula-retry-btn"
              >
                Reintentar
              </button>
            </div>
          )}

          {/* Contenido del EULA */}
          {!isLoading && !error && formattedEula && (
            <>
              <div 
                ref={contentRef}
                className="eula-content"
                id="eula-content"
                onScroll={handleScroll}
              >
                <div 
                  className="eula-text"
                  dangerouslySetInnerHTML={{ __html: formattedEula }} 
                />
                
                {!hasScrolledToBottom && (
                  <div className="eula-scroll-hint">
                    <span>Desplázate para leer todo el documento</span>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                  </div>
                )}
              </div>

              {/* Checkbox de aceptación */}
              <div className="eula-acceptance">
                <label className={`eula-checkbox-label ${!hasScrolledToBottom ? 'disabled' : ''}`}>
                  <input
                    type="checkbox"
                    checked={isAccepted}
                    onChange={(e) => setIsAccepted(e.target.checked)}
                    disabled={!hasScrolledToBottom || isSubmitting}
                    className="eula-checkbox"
                  />
                  <span className="eula-checkmark"></span>
                  <span className="eula-checkbox-text">
                    He leído y acepto los términos y condiciones de uso
                  </span>
                </label>
              </div>

              {/* Botones de acción */}
              <div className="eula-actions eula-btn-actions">
                <button
                  onClick={handleDecline}
                  disabled={isSubmitting}
                  className="eula-btn eula-btn-secondary"
                  type="button"
                >
                  Rechazar
                </button>
                
                <button
                  onClick={handleAccept}
                  disabled={!isAccepted || isSubmitting}
                  className={`eula-btn eula-btn-primary ${isSubmitting ? 'loading' : ''}`}
                  type="button"
                >
                  {isSubmitting ? (
                    <>
                      <div className="btn-loader"></div>
                      <span>Procesando...</span>
                    </>
                  ) : (
                    'Aceptar y Continuar'
                  )}
                </button>
              </div>
            </>
          )}
        </GlassCard>
    </div>
  );
};

export default EulaModal;